import type { ReactNode } from 'react';
import type { ForegroundTone } from '../../utils/style/types.js';
import type { AriaLabelingProps, CommonProps } from '../types.js';

/**
 * Props available on all typography components.
 */
export interface BaseTypographyProps extends CommonProps, AriaLabelingProps {
  /** Text to display. Allows nesting other typography components. */
  children: ReactNode;
}

export interface TextStyleOptions {
  /** Determines the visual variant of text. */
  variant?:
    | 'title-1'
    | 'title-2'
    | 'title-3'
    | 'title-4'
    | 'title-5'
    | 'title-6'
    | 'body'
    | 'body-semibold'
    | 'medium'
    | 'medium-semibold'
    | 'small'
    | 'small-semibold';
  /** Whether the font should be styled with a normal or italic face. */
  fontStyle?: 'normal' | 'italic';
  /** Horizontal alignment of text. */
  alignment?: 'start' | 'center' | 'end' | 'justify';
  /** The kind of decorative line applied to the text. */
  textDecoration?: 'none' | 'strikethrough' | 'underline';
  /** Determines the color tone of the text. */
  tone?: ForegroundTone;
}
